/**
 * @param {string} filterKey, required key for query
 * @param {array} searchValues, array of searched items [{name: 'status', value: approved}]
 * @returns {*[]}
 */
const getSearchQuery = (filterKey, searchValues) => {
  if (!searchValues || !filterKey) {
    return [];
  }

  return searchValues.map((item) => {
    return {
      name: `${filterKey}[${item.name}]`,
      value: JSON.stringify(item.value),
    };
  });
};

export default getSearchQuery;
